<template>
    <div class="position-relative celebration">
        <UtilsContent @close-action="closeQuestion" content-width="55" content-width-unit="vw">
            <template v-slot:header>
                <v-row class="d-flex flex-row justify-start align-start mx-3">
                    <v-col cols="1" class="d-flex justify-center align-center">
                        <img :src="questionsImg" class="img-index mr-2" alt=""/>
                    </v-col>
                    <v-col cols="10" class="text-justify px-0">
                         <span
                             class="text-h5 ma-0 text--primary"
                         >{{ $t('bookReading.question') }}</span
                         >
                    </v-col>
                </v-row>
            </template>
            <template v-slot:content>
                <div
                    class="d-flex flex-column questions-container"
                    id="questions-container"
                    v-if="questions.length"
                >
                    <QuestionItem
                        :data="currentQuestion"
                        :cleanSelection="cleanCounter"
                        @newSelection="newSelection"
                        v-if="currentQuestion"
                        ref="questionItem"
                    />
                </div>
                <div class="d-flex flex-column questions-container" v-else>
                    <span class="text-h6 text--primary">No hay preguntas en este momento.</span>
                </div>
            </template>
            <template v-slot:actions v-if="questions.length">
                <v-btn
                    data-cy="question-nextQuestion-button"
                    color="secondary"
                    rounded
                    class="mt-5 py-5 px-10 text--white"
                    @click="evaluateQuestion"
                    v-if="showButtonForRegularStudent && showNextQuestionButton"
                    ><span class="text--white text-capitalize">{{
                        $t('initialTour.next_question')
                    }}</span></v-btn
                >
                <v-btn
                    data-cy="question-nextQuestion-button"
                    color="secondary"
                    rounded
                    class="mt-5 py-5 px-10 text--white"
                    @click="validateQuestion"
                    v-if="showInitialReaderFlow"
                ><span class="text--white text-capitalize">{{
                        $t('bookReading.answer')
                    }}</span></v-btn
                >
                <v-btn
                    data-cy="question-nextQuestion-button"
                    color="secondary"
                    rounded
                    class="mt-5 py-5 px-10 text--white"
                    @click="moveNextQuestion"
                    v-if="!showButtonForRegularStudent && showNextQuestionButton && showAdvanceNextQuestion"
                ><span class="text--white text-capitalize">{{
                        $t('initialTour.next_question')
                    }}</span></v-btn
                >
                <v-btn
                    data-cy="question-finishQuestions-button"
                    v-if="showButtonForRegularStudent && showSendChallengeResult"
                    color="secondary"
                    rounded
                    :loading="resolveLoader"
                    class="mt-5 py-5 px-10 text--white"
                    @click="finishChallenge"
                    ><span  class="text--white text-capitalize">{{
                        $t('challenge.resolve_challenge')
                    }}</span></v-btn
                >
                <v-btn
                    data-cy="question-finishQuestions-button"
                    v-if="!showButtonForRegularStudent && showSendChallenge"
                    color="secondary"
                    rounded
                    :loading="resolveLoader"
                    class="mt-5 py-5 px-10 text--white"
                    @click="sendChallenge"
                ><span  class="text--white text-capitalize">{{
                        $t('challenge.resolve_challenge')
                    }}</span></v-btn
                >
            </template>
        </UtilsContent>
        <div
            :class="
                'position-absolute transition-all ' +
                (showOptions ? 'three-img-corner-button' : 'img-corner-button')
            "
            @click="showOptions = !showOptions"
            v-if="questions.length && !isInitialReader"
        ></div>
        <div
            class="position-absolute transition-all wildcard-button"
            v-if="showOptions"
            @click="openWildCardModal"
        ></div>
        <div
            class="position-absolute transition-all tip-button"
            @click="showTips"
            v-if="showOptions"
        ></div>
        <v-btn
            icon
            class="position-absolute transition-all cls-button"
            v-if="showOptions"
            @click="showOptions = !showOptions"
        >
            <v-icon class="text--primary">mdi-close</v-icon>
        </v-btn>
        <audio
            id="correct_audio"
            :src="global.GAMIFICATION_SOUNDS + 'answer_correct.mp3'"
            crossOrigin="anonymous"
        ></audio>
        <audio
            id="incorrect_audio"
            :src="global.GAMIFICATION_SOUNDS + 'answer_incorrect.mp3'"
            crossOrigin="anonymous"
        ></audio>
        <audio
            id="tips_audio"
            :src="global.GAMIFICATION_SOUNDS + 'question_tip_used.mp3'"
            crossOrigin="anonymous"
        ></audio>
        <audio
            id="wildcard_audio"
            :src="global.GAMIFICATION_SOUNDS + 'question_wildcard_used.mp3'"
            crossOrigin="anonymous"
        ></audio>
        <TipsModal
            v-if="currentTip"
            :dialog="showTipsModal"
            :tip_number="tipIndex + 1"
            :total_tips="tips.length"
            :tip_text="currentTip.detail"
            @close-modal="closeTipsModal"
        />
        <WildcardModal
            :dialog="showWildCardModal"
            :count_beecoins="coins"
            :wildcard_price="global.WILDCARD_PRICE"
            @close-modal="closeWildcardModal"
            @confirm="confirmBuyWildCard"
        />
        <WildcardUsedModal :dialog="showWildCardUsedModal" />
        <ChallengeSuccessModal
            :dialog="showSuccessModal"
            :success="challenge_repechaje < 2"
            :pointsWon="pointsWon"
            :coinsWon="coinsWon"
            @exit-challenge="exitChallenge"
            @new-challenge="newChallenge"
        />
        <ResultMsgModal
            :dialog="showResultModal"
            :count_corrects="correctAnswers.length"
            :finish="challenge_repechaje === 2"
            @try-again="tryAgain"
            @collect-prize="collectPrize"
            @finish-action="failAction"
        />
        <FailModal :dialog="showFailModal" @continue="collectPrize" />
    </div>
</template>
<script>
/* eslint-disable global-require */
import { mapState, mapActions } from 'vuex'
import global from '@/constants/GlobalConstant'

import {confetti} from 'dom-confetti'
import TipsModal from '@/components/reading/content/bookUtils/modals/TipsModal.vue'
import WildcardModal from '@/components/reading/content/bookUtils/modals/WildcardModal.vue'
import WildcardUsedModal from '@/components/reading/content/bookUtils/modals/WildcardUsedModal.vue'
import challengeService from '@/services/challenge'
import gamificationService from '@/services/gamification'
import QuestionItem from './items/QuestionItem.vue'
import ChallengeSuccessModal from './modals/ChallengeSuccessModal.vue'
import ResultMsgModal from './modals/ResultMsgModal.vue'
import FailModal from './modals/FailModal.vue'
import UtilsContent from "../../../core/utils/UtilsContent";
import initialReaderValidation from '@/mixins/InitialReaderValidation'
import {CONFETTI_SETUP} from '../../../../constants/DefaultConstants'


export default {
    components: {
        UtilsContent,
        QuestionItem,
        TipsModal,
        WildcardModal,
        WildcardUsedModal,
        ChallengeSuccessModal,
        ResultMsgModal,
        FailModal,
    },
    computed: {
        ...mapState({
            questions: (state) => state.challenge.questions,
            evaluationId: (state) => state.challenge.evaluationId,
            testId: (state) => state.challenge.testId,
            tiempoEmpleadoLectura: (state) => state.challenge.tiempoEmpleadoLectura,
            tiempoEmpleadoReLectura: (state) => state.challenge.tiempoEmpleadoReLectura,
            testNuncaAplicado: (state) => state.challenge.testNuncaAplicado,
            itemsData: (state) => state.bookReading.itemsData,
            coins: (state) => state.userData.coins,
            points: (state) => state.userData.points,
            user: (state) => state.userData.user,
            tipsData: (state) => state.bookReading.tipsData,
            course: (state) => state.userData.user.course,
        }),
        showButtonForRegularStudent(){
            return !this.isInitialReader
        },
        showNextQuestionButtonForInitialReader(){
            return this.indexQuestion <= this.questions.length - 1
        },
        showNextQuestionButton(){
            return this.indexQuestion < this.questions.length - 1
        },
        showInitialReaderFlow() {
            return !this.showButtonForRegularStudent && this.showNextQuestionButtonForInitialReader && !this.showAdvanceNextQuestion && !this.showSendChallenge
        },
        showSendChallengeResult(){
            return this.indexQuestion === (this.questions.length - 1)
        },
        tips() {
            const {ordinalGrade} = this.user.course
            return this.currentQuestion ?
                this.filterByGrade(
                    this.currentQuestion.aimOfAssessmentDTO.tips,
                    ordinalGrade
                ) : []
        },
    },
    data() {
        return {
            questionsImg: require('@/assets/img/icons/reading/3-questions.svg'),
            showOptions: false,
            secondChance: false,
            correct: false,
            asked: false,
            usedWildcard: false,
            audioCorrect: 'correct_audio',
            audioIncorrect: 'incorrect_audio',
            audioUseWildcard: 'wildcard_audio',
            audioTips: 'tips_audio',
            showTipsModal: false,
            tipIndex: -1,
            currentTip: null,
            showWildCardModal: false,
            global,
            showWildCardUsedModal: false,
            currentQuestion: null,
            indexQuestion: 0,
            answerFinish: [],
            correctAnswers: [],
            incorrectAnswers: [],
            timeToResponse: 0,
            timer: null,
            challenge_repechaje: 0,
            lastSend: false,
            showSuccessModal: false,
            showResultModal: false,
            resolveLoader: false,
            showFailModal: false,
            coinsWon: 0,
            pointsWon: 0,
            selectedOption: {
                id: null,
                value: null,
                secret: null,
            },
            cleanCounter: 0,
            attempts:  1,
            showAdvanceNextQuestion: false,
            showSendChallenge: false,
        }
    },
    methods: {
        ...mapActions('userData', ['setCoins', 'setPoints']),
        ...mapActions('challenge', [
            'increaseReadingTime',
            'increaseReReadingTime',
            'resetTimers',
            'clearMainTimer',
            'clearSecondaryTimer',
            'clearAllTimers',
            'setReadingTime',
            'setReReadingTime',
            'ShowQuestion',
            'setQuestions',
            'setChallengeData',
            'resetChallengeState',
        ]),
        closeQuestion() {
            this.$emit('close-question')
        },
        celebrateSuccess(el = null){
            if(el) confetti(el, CONFETTI_SETUP)
        },
        evaluateQuestion(){
            if (this.evaluateValue(this.selectedOption)) {
                const { secret, value } = this.selectedOption;
                this.manageObjs(value, secret);
                this.cleanOptions();
                this.nextQuestion();
            }
        },
        validateQuestion() {
            if (this.evaluateValue(this.selectedOption)) {
                const {attempts, currentQuestion} = this;
                const { mdTestPreguntaRespuestaCorrecta } = currentQuestion;
                const { secret, value } = this.selectedOption;
                this.addToAnswerFinish({
                    idPregunta: currentQuestion.id,
                    idRespuesta: value,
                    tiempoEmpleadoRespuesta: this.timeToResponse,
                    attempts
                }, false);

                if (this.isCorrect(mdTestPreguntaRespuestaCorrecta, secret)) {
                    this.setSoundEffect();
                    this.$refs.questionItem.setCorrectAnswer(this.currentQuestion.id, this.selectedOption.id );
                    this.addToCorrect(currentQuestion);
                    this.attempts = 1;
                    if (this.showSendChallengeResult) {
                        this.showSendChallenge = true;
                    } else {
                        this.showAdvanceNextQuestion = true;
                    }
                } else {
                    this.setSoundEffect(false);
                    this.$refs.questionItem.setWrongAnswer(this.currentQuestion.id, this.selectedOption.id );
                    this.increaseAttempts();
                    this.cleanOptions();
                }
            }
        },
        setSoundEffect(success = true){
            if(success){
                this.playSound(this.audioCorrect);
                this.celebrateSuccess(document.querySelector('.celebration'));
            }else {
                this.playSound(this.audioIncorrect);
            }
        },
        sendFinishChallengeRequest() {
            return new Promise(async (resolve, reject) => {
                try {
                    const data = {
                        challenge_repechaje: this.challenge_repechaje,
                        lastSend: this.challenge_repechaje === 2 || this.correctAnswers.length === 4,
                        lbUserId: this.user.id,
                        mdEvaluacionId: this.evaluationId,
                        mdTestId: this.testId,
                        testNuncaAplicado: this.testNuncaAplicado,
                        tiempoEmpleadoLectura: this.tiempoEmpleadoLectura,
                        tiempoEmpleadoRelectura: this.tiempoEmpleadoReLectura || 0,
                        mdTestPreguntaRespuestaFinishDTOS: this.answerFinish,
                    };
                    const {content} = await challengeService.finish(data);
                    const {coinGanados, puntosGanados} = content;
                    this.coinsWon = coinGanados;
                    this.pointsWon = puntosGanados;
                    this.showResultModal = true;
                    window.ChurnZero.push(['trackEvent', 'answerChallengeQuestion', 'Send answer in challenge question']);
                    this.$ga.event('userClick', 'answerChallengeQuestion')
                    resolve(content)
                } catch (error) {
                    reject(error)
                }
                this.resolveLoader = false
            });
        },
        moveNextQuestion(){
            this.cleanOptions();
            this.nextQuestion();
            this.$refs.questionItem.cleanStyles();
            this.showAdvanceNextQuestion = false
        },
        increaseAttempts(){
            this.attempts += 1
        },
        manageObjs(value, secret) {
            const {attempts, currentQuestion} = this;
            const { mdTestPreguntaRespuestaCorrecta } = currentQuestion;
            this.addToAnswerFinish({
                idPregunta: currentQuestion.id,
                idRespuesta: value,
                tiempoEmpleadoRespuesta: this.timeToResponse,
                attempts
            });
            if (this.isCorrect(mdTestPreguntaRespuestaCorrecta, secret)) {
                this.addToCorrect(currentQuestion)
            } else {
                this.addToIncorrect(currentQuestion)
            }
        },
        isCorrect({item = null}, secret = null){
            return item ? item === parseInt(secret, 10): false
        },
        newSelection(selectionParam) {
            this.selectedOption = selectionParam
        },
        nextQuestion() {
            this.indexQuestion += 1
            this.currentQuestion = this.questions.at(this.indexQuestion)
            this.timeToResponse = 0
            this.tipIndex = -1
            this.usedWildcard = false
        },
        filterByGrade(tips, grade) {
            const result = []
            tips.forEach((tip) => {
                if (tip.educationLevel === 'ALL') {
                    result.push(tip)
                }

                if (grade >= 1 && grade <= 6 && tip.educationLevel === 'PRIMARY') {
                    result.push(tip)
                }

                if (grade >= 7 && grade <= 12 && tip.educationLevel === 'SECONDARY') {
                    result.push(tip)
                }
            })
            return result
        },
        async sendChallenge(){
            try {
                this.resolveLoader = true;
                await this.sendFinishChallengeRequest();
            } catch (error) {
                Sentry.captureException(error);
                this.$modal.error(error.message)
            }
        },
        async finishChallenge() {
            try {
                this.resolveLoader = true;
                const value = this.evaluateValue(this.selectedOption);
                if (value) {
                    const {secret} = this.selectedOption;
                    this.manageObjs(value, secret);
                    await this.sendFinishChallengeRequest();
                }
            } catch (error) {
                Sentry.captureException(error);
                this.$modal.error(error.message);
            } finally {
                this.resolveLoader = false;
            }
        },
        addToAnswerFinish(object, findExistingObject = true) {
            if (this.answerFinish.length && findExistingObject) {
                const found = this.answerFinish.find((el) => el.idPregunta === object.idPregunta);
                if (!found) this.answerFinish = [...this.answerFinish, object];
                else this.answerFinish[this.answerFinish.indexOf(found)] = object;
            } else {
                this.answerFinish = [...this.answerFinish, object];
            }
        },
        addToCorrect(obj) {
            if (this.correctAnswers.length) {
                const found = this.correctAnswers.find((el) => el.id === obj.id);
                const foundIncorrect = this.incorrectAnswers.find((el) => el.id === obj.id);

                if (!found) this.correctAnswers = [...this.correctAnswers, obj];
                else this.correctAnswers[this.correctAnswers.indexOf(found)] = obj;

                if (foundIncorrect)
                    this.incorrectAnswers.splice(this.incorrectAnswers.indexOf(foundIncorrect), 1)
            } else {
                this.correctAnswers = [...this.correctAnswers, obj]
            }
        },
        addToIncorrect(obj) {
            if (this.incorrectAnswers.length) {
                const found = this.incorrectAnswers.find((el) => el.id === obj.id);

                if (!found) this.incorrectAnswers = [...this.incorrectAnswers, obj];
                else this.incorrectAnswers[this.incorrectAnswers.indexOf(found)] = obj;

            } else {
                this.incorrectAnswers = [...this.incorrectAnswers, obj]
            }
        },
        evaluateValue({id = 0, value = null}) {
            if (id) return value;
            this.$modal.error(this.$t('initialTour.select_option'));
            return false;
        },
        tryAgain() {
            this.cleanOptions()
            if (this.incorrectAnswers.length) {
                this.challenge_repechaje += 1
                this.indexQuestion = 0
                const arrTemp = [...this.incorrectAnswers]
                this.setQuestions(arrTemp)
                this.currentQuestion = this.questions.at(this.indexQuestion)
                this.incorrectAnswers = []
            }
            this.ShowQuestion()
            this.setReadingTime(new Date().getTime())
            this.setReReadingTime(new Date().getTime())
            this.showResultModal = false
            this.resolveLoader = false
        },
        collectPrize() {
            this.showResultModal = false
            this.resolveLoader = false
            this.showFailModal = false
            this.showSuccessModal = true
            this.usedWildcard = false
            this.setCoins(this.coins + this.coinsWon)
            this.setPoints(this.points + this.pointsWon)
            this.celebrateSuccess(document.getElementById('success-modal'))
        },
        async newChallenge() {
            if (!this.isInitialReader) {
                this.$loading(true);
                this.showSuccessModal = false;
                this.showResultModal = false;
                this.showFailModal = false;
                this.cleanOptions();
                this.ShowQuestion();
                this.currentQuestion = null;
                this.indexQuestion = 0;
                const { content } = await challengeService.initTest(this.user.id, false, this.isInitialReader)
                this.resetChallengeState();
                this.setChallengeData(content);
                this.currentQuestion = this.questions.at(this.indexQuestion);
                this.correctAnswers = [];
                this.incorrectAnswers = [];
                this.answerFinish = [];
                this.challenge_repechaje = 0;
                this.$loading(false)
            } else this.$router.go(0)
        },
        exitChallenge() {
            this.resetChallengeState()
            this.$router.go(-1)
        },
        failAction() {
            this.showResultModal = false
            this.showFailModal = true
        },
        cleanOptions() {
            this.selectedOption = {
                id: null,
                value: null,
                secret: null,
            };
            this.cleanCounter += 1;
            document.querySelectorAll('.hide-option').forEach((el) => {
                el.classList.toggle('hide-option')
            })
        },
        playSound(player) {
            document.getElementById(player).play()
        },
        showTips() {
            this.tipIndex += 1
            if (this.tipIndex <= this.tips.length - 1) {
                this.playSound(this.audioTips)
                this.currentTip = this.tips.at(this.tipIndex)
                this.showTipsModal = true
                this.showOptions = false
                return
            }
            this.showOptions = false
            this.showTipsModal = false
            this.$modal.warning('Ya has utilizado todas las pistas para esta pregunta.')
        },
        closeTipsModal() {
            this.showTipsModal = false
            this.showOptions = false
        },
        closeWildcardModal() {
            this.showWildCardModal = false
            this.usedWildcard = false
        },
        confirmBuyWildCard() {
            if (this.coins < this.global.WILDCARD_PRICE) {
                this.$modal.error(this.$t('bookReading.without_beecoins'))
                return
            }
            const vm = this
            gamificationService
                .confirmAction(this.user.id, this.global.WILDCARD_PRICE)
                .catch((error) => console.error(error))
            this.playSound(this.audioUseWildcard)
            this.setCoins(this.coins - this.global.WILDCARD_PRICE)
            const currentQuestion = this.questions[this.indexQuestion]
            const optionsToHide = currentQuestion.mdTestPreguntaRespuestases.filter(
                (answer) => answer.item !== 4
            )
            optionsToHide.forEach((opt, index) => {
                if (index === 1 || index === 0) {
                    const el = document.getElementById(opt.id)
                    if (el) el.classList.toggle('hide-option')
                }
            })
            this.usedWildcard = true
            this.showOptions = false
            this.showWildCardModal = false
            this.showWildCardUsedModal = true
            setTimeout(() => {
                vm.showWildCardUsedModal = false
            }, 5000)
        },
        openWildCardModal() {
            if (this.usedWildcard) {
                this.$modal.error(this.$t('bookReading.wildcard_alredy_use'))
                return
            }
            this.showWildCardModal = true
            this.showOptions = false
        },
        increaseTime() {
            this.timeToResponse += 1
        },
    },
    mixins: [initialReaderValidation],
    mounted() {
        const vm = this
        this.currentQuestion = this.questions.at(this.indexQuestion)
        this.timer = setInterval(() => {
            vm.increaseTime()
        }, 1000)
    },
}
</script>
<style>
.questions-container {
    max-height: 70vh;
    overflow: auto;
}

.img-corner-button {
    background: url(../../../../assets/img/gamifications/comodin-001.svg) round;
    z-index: 11;
}

.img-corner-button:hover {
    background: url(../../../../assets/img/gamifications/comodin-003.svg) round;
    cursor: pointer;
}
.three-img-corner-button {
    background: url(../../../../assets/img/gamifications/comodin-004.svg) round;
    cursor: pointer;
    z-index: 11;
}

.wildcard-button {
    background: url(../../../../assets/img/gamifications/50-50.svg) round;
    cursor: pointer;
    z-index: 11;
}

.tip-button {
    background: url(../../../../assets/img/gamifications/pistas.svg) round;
    cursor: pointer;
    z-index: 11;
}

.cls-button {
    z-index: 11;
    bottom: 17.5vh;
    left: 1vh;
}

.wildcard-button:hover,
.tip-button:hover {
    bottom: 2.5em;
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
    .img-corner-button {
        bottom: -10vh;
        left: -10vh;
        z-index: 11;
        width: 25vh;
        height: 25vh;
        padding: 8vh;
    }

    .img-corner-button:hover {
        bottom: -10vh;
        left: -10vh;
        width: 25vh;
        height: 25vh;
        padding: 8vh;
    }
    .three-img-corner-button {
        bottom: -10vh;
        left: -10vh;
        width: 25vh;
        height: 25vh;
        padding: 8vh;
    }

    .wildcard-button {
        bottom: 2vh;
        left: 0vh;
        z-index: 11;
        width: 18vh;
        height: 18vh;
    }

    .tip-button {
        bottom: 2vh;
        left: -14vh;
        z-index: 11;
        width: 18vh;
        height: 20vh;
    }

    .wildcard-button:hover,
    .tip-button:hover {
        bottom: 2.5vh;
    }
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
    .questions-container {
        max-height: 55vh;
        overflow: auto;
    }

    .img-corner-button {
        bottom: -9vh;
        left: -9vh;
        z-index: 11;
        width: 15vh;
        height: 15vh;
        padding: 11.5vh;
    }

    .img-corner-button:hover {
        bottom: -9vh;
        left: -9vh;
        z-index: 11;
        width: 15vh;
        height: 15vh;
        padding: 11.5vh;
    }
    .three-img-corner-button {
        bottom: -9vh;
        left: -9vh;
        z-index: 11;
        width: 15vh;
        height: 15vh;
        padding: 11.5vh;
    }

    .wildcard-button {
        bottom: 2vh;
        left: -2.5vh;
        z-index: 11;
        width: 15vh;
        height: 15vh;
    }

    .tip-button {
        bottom: 2vh;
        left: -15vh;
        z-index: 11;
        width: 15vh;
        height: 16.5vh;
    }

    .wildcard-button:hover,
    .tip-button:hover {
        bottom: 2.5vh;
    }
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
    .questions-container {
        max-height: 70vh;
        overflow: auto;
    }
    .img-corner-button {
        bottom: -9vh;
        left: -9vh;
        z-index: 11;
        width: 22.5vh;
        height: 22.5vh;
        padding: 10vh;
    }

    .img-corner-button:hover {
        bottom: -9vh;
        left: -9vh;
        z-index: 11;
        width: 22.5vh;
        height: 22.5vh;
        padding: 10vh;
    }
    .three-img-corner-button {
        bottom: -9vh;
        left: -9vh;
        z-index: 11;
        width: 22.5vh;
        height: 22.5vh;
        cursor: pointer;
        padding: 10vh;
    }

    .wildcard-button {
        bottom: 2vh;
        left: 1vh;
        z-index: 11;
        width: 15vh;
        height: 15vh;
        cursor: pointer;
    }

    .tip-button {
        bottom: 2vh;
        left: -9vh;
        z-index: 11;
        width: 12vh;
        height: 16vh;
        cursor: pointer;
    }

    .wildcard-button:hover,
    .tip-button:hover {
        bottom: 3.5vh;
    }
}

.hide-option {
    display: none !important;
    clear: both;
}
</style>
